<script>
import moment from 'moment';
import Layout from "../../layouts/main";
import DatePicker from "vue2-datepicker";
import 'vue2-datepicker/locale/pt-br';
import appConfig from "@/app.config";

import ActivityService from '@/services/activity'

moment.locale('pt-BR');

export default {
  page: {
    title: "Listagem de Atividades",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { Layout, DatePicker },
  data() {
    return {
      title: "Listagem de Atividades",

      loading: false,
      activities: [],
      searchParams: {
        term: '',
        startDate: '',
        endDate: '',
        period: true,
      },
      showModal: false,
      searchEmptyField: false,
      activity: {},

      count: 0,
      currentCount: 0,
      currentPage: 1,
      totalPages: 0,
      perPage: 0,
      startIndex: 0,
      endIndex: 0,

      fields: [
        { key: 'date', sortable: true, label: 'Data', formatter: (value) => {
          return moment(value).format('DD/MM/YYYY HH:mm:ss');
        } },
        { key: 'sellerName', sortable: true, label: 'Vendedor' },
        { key: 'customerName', sortable: true, label: 'Cliente' },
        { key: 'type', sortable: true, label: 'Tipo' },
        { key: 'content', sortable: true, label: 'Conteúdo' },
        { key: 'actions', label: '', class: 'nowrap-col' }
      ],
    };
  },
  mounted() {
    const now = new Date();
    const startDate = new Date();
    startDate.setDate(startDate.getDate() - 7);

    this.searchParams.startDate = startDate;
    this.searchParams.endDate = now;

    this.search();
  },
  methods: {
    search() {
      this.searchEmptyField = false;
      this.loadActivities();
    },
    loadActivities(page = 1) {
      this.loading = true;

      if (!this.searchParams.startDate) {
        if (!this.searchParams.endDate) {
          this.searchParams.endDate = new Date();
        }
        
        const startDate = new Date(this.searchParams.endDate);
        startDate.setDate(startDate.getDate() - 7);
        this.searchParams.startDate = startDate;
      }

      if (!this.searchParams.endDate) {
        this.searchParams.endDate = new Date();
      }

      this.searchParams.page = page;

      ActivityService.getAll(this.searchParams)
        .then(res => {
          this.loading = false;

          this.activities = res.data.activities;
          this.count = res.data.count;
          this.currentCount = res.data.currentCount;
          this.currentPage = res.data.currentPage;
          this.totalPages = res.data.totalPages;
          this.perPage = res.data.perPage;
          this.startIndex = res.data.startIndex;
          this.endIndex = res.data.endIndex;

          this.totalSales = res.data.totalSales;
          this.totalCanceledSales = res.data.totalCanceledSales;
          this.totalValidSales = res.data.totalValidSales;
        })
      .catch(() => {
        this.loading = false;
      })
    },
    onPageChange() {
      window.scrollTo(0,0);
      this.loadActivities(this.currentPage);
    },
    exportData() {
      this.loading = true;

      ActivityService.exportActivities(this.searchParams).then(res => {
        this.loading = false;
        
        var fileURL = window.URL.createObjectURL(new Blob([res.data]));
        var fileLink = document.createElement('a');

        fileLink.href = fileURL;
        fileLink.setAttribute('download', 'Atividades.xlsx');
        document.body.appendChild(fileLink);

        fileLink.click();
      }).catch(() => {
        this.loading = false;
      })
    },
    details(activity) {
      this.activity = activity;
      this.showModal = true;
    },
    formatDate(value) {
      return moment(value).format('DD/MM/YYYY HH:mm:ss');
    },
    changeSearch() {
      if (this.searchParams.term === '' && !this.searchEmptyField) {
        this.searchEmptyField = true;
        this.loadActivities(1);
      }
    }
  }
};
</script>

<template>
  <Layout>
    <div class="row">
      <div class="col-12">
        <div class="page-title-box d-flex align-items-center justify-content-between">
          <h4 class="mb-0 font-size-18">{{title}}</h4>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <form @submit.prevent="search" class="align-items-center">
              <div class="row">
                <div class="col-lg-6 col-sm-12">
                  <div class="form-group">
                    <label>Código, CNPJ, Razão Social ou Nome Fantasia</label>
                    <input
                      type="text"
                      v-model="searchParams.term"
                      v-on:keyup="changeSearch"
                      class="form-control"
                      placeholder="Informe o nome do cliente"
                    />
                  </div>

                  <div class="custom-control custom-checkbox mb-2">
                    <input type="checkbox" class="custom-control-input" id="customCheck1" v-model="searchParams.period" />
                    <label class="custom-control-label" for="customCheck1">Período</label>
                  </div>
                  
                  <div class="row">
                    <div class="col-6">
                      <div class="form-group mb-3">
                        <!-- <label>Período de</label> -->
                        <date-picker
                          v-model="searchParams.startDate"
                          :first-day-of-week="1"
                          format="DD/MM/YYYY"
                          lang="pt-br"
                          :disabled="!searchParams.period"
                        ></date-picker>
                      </div>
                    </div>

                    <div class="col-6">
                      <div class="form-group mb-3">
                        <!-- <label>até</label> -->
                        <date-picker
                          v-model="searchParams.endDate"
                          :first-day-of-week="1"
                          format="DD/MM/YYYY"
                          lang="pt-br"
                          :disabled="!searchParams.period"
                        ></date-picker>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-3">
                  <b-button type="submit" variant="primary" v-if="!loading">Filtrar</b-button>
                  <b-button class="ml-2" variant="outline-primary" @click="exportData" v-if="!loading">Exportar</b-button>
                  <a href="javascript:void(0);" class="text-primary" v-if="loading">
                    <b-spinner class="ml-2" variant="primary" role="status"></b-spinner>
                  </a>
                </div>

                <div class="col-3 text-sm-right">
                  <router-link tag="a" to="/select-customer?action=activity">
                    <b-button class="text-sm-right" variant="primary" @>
                      <i class="bx bx-plus-circle font-size-16 align-middle mr-2"></i>
                      NOVA ATIVIDADE
                    </b-button>
                  </router-link>
                </div>
              </div>

              <!-- <div class="button-search">
                <b-button type="submit" variant="primary" v-if="!loading">Filtrar</b-button>
                <b-button class="ml-2" variant="outline-primary" @click="exportData" v-if="!loading">Exportar</b-button>
                <a href="javascript:void(0);" class="text-primary" v-if="loading">
                  <b-spinner class="ml-2" variant="primary" role="status"></b-spinner>
                </a>

                <b-button type="submit" class="text-sm-right" variant="primary" v-if="!loading">Filtrar</b-button>
              </div> -->
            </form>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body"> 
            <div class="table-responsive mb-0">
              <b-table
                show-empty
                emptyText="Nenhum registro para exibir"
                :items="activities"
                :fields="fields"
                responsive="sm"
                head-variant="light"
              >
                <template v-slot:cell(actions)="row">
                  <a href="javascript:void(0);" class="action-icon text-success mr-3" @click="details(row.item)">
                    <i class="mdi mdi-eye font-size-18"></i>
                  </a>
                </template>
              </b-table>
            </div>
          </div>
        </div>

        <div class="row justify-content-md-between align-items-md-center mt-4">
          <div class="col-xl-7">Mostrando {{startIndex}} - {{endIndex}} de {{count}}</div>
          <!-- end col-->
          <div class="col-xl-5">
            <div class="text-md-right float-xl-right mt-2 pagination-rounded">
              <b-pagination
                v-model="currentPage" 
                :total-rows="count"
                :per-page="perPage"
                @input="onPageChange"
              ></b-pagination>
            </div>
          </div>
          <!-- end col-->
        </div>
      </div>
    </div>

    <b-modal v-model="showModal" title="Detalhes da Atividade" centered>
      <div class="customer-detail">
        <div class="field">
          <p class="title">Cliente:</p>
          <p>{{activity.customerName}}</p>
        </div>
        <div class="field">
          <p class="title">Data:</p>
          <p>{{formatDate(activity.date)}}</p>
        </div>
        <div class="field">
          <p class="title">Tipo:</p>
          <p>{{activity.type}}</p>
        </div>
        <div class="field">
          <p class="title">Conteúdo:</p>
          <p>{{activity.content}}</p>
        </div>
      </div>
      <template v-slot:modal-footer>
        <b-button variant="primary" @click="showModal = false">Fechar</b-button>
      </template>
    </b-modal>
  </Layout>
</template>

<style lang="scss">
  .customer-detail {
    .field {
      display: flex;
      flex-direction: row;

      p {
        margin-bottom: 8px;

        &.title {
          font-weight: 600;
          color: #000;
          margin-right: 16px;
        }
      }
    }
  }
</style>